import { useMutation, useQueryClient } from "@tanstack/react-query";
import useApiAdmin from "./useApiAdmin";
import UserMedal from "../interfaces/userMedal";

const useCreateUserMedal = () => {
    const { createUserMedal } = useApiAdmin();

    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ token, userId, medals }: { token: string; userId: string; medals: UserMedal[] }) => 
            createUserMedal(token, userId, medals),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["userMedal"]});
        }
    })
}

export default useCreateUserMedal;